export const STRIPE_APPEARANCE = {
  theme: 'none',
  variables: {
    borderRadius: '12px',
    colorBackground: '#ffffff',
    colorText: '#252525',
    colorDanger: '#9e2146',
    fontFamily:
      'Inter, system-ui, -apple-system, Segoe UI, Roboto, sans-serif',
  },
  rules: {
    '.Label': {
      color: '#4C4C4C',
      fontSize: '14px',
      marginBottom: '8px',
      fontWeight: '500',
    },
    '.Input': {
      border: '1px solid #D0D5DD',
      padding: '14px 16px',
      borderRadius: '12px',
      backgroundColor: '#ffffff',
      color: '#252525',
    },
    '.Input::placeholder': { color: '#8A9197' },
    '.Input:focus': {
      borderColor: '#FF9554',
      boxShadow: '0 0 0 1px #FF9554',
    },
    '.Input--invalid': { borderColor: '#9e2146' },
    '.Error': {
      color: '#E53E3E',
      fontSize: '12px',
      marginTop: '10px',
      marginLeft: '5px',
    },
    '.Tab, .Block, .Button': { borderRadius: '12px' },
    '.AccordionItem': { borderRadius: '12px' },
    '.Row': { marginBottom: '16px' },
    '.Row:last-child': { marginBottom: '0px' },
  },
};
